import { render, staticRenderFns } from "./DiscoveryBoxRate.vue?vue&type=template&id=2f509444"
import script from "./DiscoveryBoxRate.vue?vue&type=script&lang=js"
export * from "./DiscoveryBoxRate.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryBoxRate.vue?vue&type=style&index=0&id=2f509444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports